import { inspectionDB } from '../../data/database.structure';
import { syncInspectionImages } from '../../hooks/inspectionSync/imageSyncCore';
import {
  inspectionNotStored,
  inspectionRecordService,
} from '../inspection/inspectionRecordService';
import { PhotoDeliveryService } from './photoDeliveryCore';

export type {
  PhotoDeliveryOutcome,
  PhotoProgressListener,
} from './photoDeliveryCore';
export { PhotoDeliveryService } from './photoDeliveryCore';

/**
 * The photo sender the Submit screen and background sync share: uploads the photos the
 * server hasn't received, from the current stored record, then finishes delivery when
 * none failed, or records the failure (#11590, SY-6).
 */
export const photoDeliveryService = new PhotoDeliveryService(
  async (externalId, progress) => {
    const current = await inspectionDB.inspections.get(externalId);
    if (!current) throw inspectionNotStored(externalId);
    const outcome = await syncInspectionImages(current, progress);
    if (outcome.failures.length === 0) {
      await inspectionRecordService.finishDelivery(externalId);
    } else {
      await inspectionRecordService.recordSendFailure(
        externalId,
        outcome.failure ?? {
          counted: false,
          reason: 'Photos could not be sent.',
        },
      );
    }
    return outcome;
  },
);
